import React from 'react';
import withRipple from 'jd-library/withRipple';

const MobileFilterRipple = props => {
    return (
        <div className={props.rippleClass + ' ' + props.className} {...props.rippleHandler} onClick={props.clickHandler} role={props.role} tabIndex={props.tabIndex} onKeyDown={props.onKeyDown}>
            {props.renderRipple()}
            {props.children}
        </div>
    );
}

export default withRipple(MobileFilterRipple);
